module.exports = __webpack_public_path__ + "img/export-financials.8b1c13f2.svg";